export default __webpack_public_path__ + "media/flags/me-957be31b.svg";